import { render, staticRenderFns } from "./mNav.vue?vue&type=template&id=be018050&scoped=true&"
import script from "./mNav.vue?vue&type=script&lang=js&"
export * from "./mNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be018050",
  null
  
)

export default component.exports